import React, { useState, useEffect } from 'react'
import { Container } from 'react-bootstrap'
import { BigCard, Tabela, Header } from '@equipedigitalfloripa/ed-cms/components'
import * as SliderApi from '../api/slider'

export default function Slider() {

    const columns = [
        {
            title: "Imagem",
            field: '_id',
            filtering: false,
            sorting: false,
            cellStyle: {
                maxWidth: 66,
            },
            render: rowData =>
                <img
                    className="noticia-img"
                    src={SliderApi.getImagemSlider(rowData._id)}
                    alt="" />
        },

        {
            title: "Ordem",
            field: "ordem",
            sorting: true
        },
        {
            title: "Nome",
            field: "nome",
            sorting: true
        },
    ];

    return (
        <React.Fragment>
            <Header title={"Slider"} subtitle={"Lista de sliders"}>
                <i className="fas fa-coins awesome-header"></i>
            </Header>
            <Container className="page-content">
                <BigCard>
                    <Tabela
                        url={'sliders'}
                        columns={columns}
                        fetchFunction={SliderApi.fetchItems}
                        removeFunction={SliderApi.removeItem}
                        statusFunction={SliderApi.statusItem}
                        enableSearch
                    />
                </BigCard>
            </Container>
        </React.Fragment>
    )
}